import laVilaCover from '../../../assets/images/la-villa-restaurant.jpg';
import shanghaiCover from '../../../assets/images/shanghai-restaurant.jpg';
import { abstract, lavillaAbout, shanghaiAbout } from './restaurants';
import shanghaiCover1 from '../../../assets/images/food/shanghai/shanghai4.jpeg';

const frontpage = {
  subtitle: 'Средиземноморская и китайская кухня',
  welcome: {
    title: 'Oб отеле',
    subtitle: 'La Villa (Ла Вилла) Бутик Отель тепло приветствует Вас и желает приятного пребывания в нашей гостинице!',
    body:
      'Почувствуйте очарование Старого Города, погрузившись в комфорт современной средиземноморской обстановки с завораживающими видами на пристань для яхт, море и Будву.\n\n' +
      'Изысканный Бутик Отель особо подчеркивает приватность, заключенную в его кондиционируемых номерах люкс, оборудованных всем необходимым. Во всех пяти номерах отеля достаточно пространства, предлагается большая кровать (king size), удобный диван, кабельное телевидение, бесплатный доступ в интернет (Wi-Fi), современная ванная комната с роскошными банными халатами, большой сейф для ноутбука и личных вещей, парковка для Вашего авто и много других неотъемлемых составных частей для отличного отдыха. Отель расположен в историческом здании 17-го века, расположенном в тихом уголке Старого Города Будвы, признанном ЮНЕСКО объектом мирового наследия.\n\n' +
      'Среди преимуществ La Villa не только идиллическое местоположение в короткой пешей доступности от песчаного пляжа Pizana (Пизана) и всего в 20 км от ближайшего аэропорта, но и прекрасная возможность предаться гастрономическим приключениям. В нашем отеле находится ресторан Шанхай с азиатской кухней. Расположившись в тени удобного крытого патио, освещенного сияющими лучами солнца, Вы сможете побаловать себя изысканными блюдами из нашего азиатского меню, деликатесами китайской или японской кухни.\n\n' +
      'La Villa Бутик Отель предлагает включенный в стоимость номеров разнообразный и богатый завтрак в черногорском стиле. Вы сможете приятно провести утренние часы, наслаждаясь завтраком в тени винограда на уединенной террасе или во внутренней части элегантного ресторана La Villa.\n\n' +
      'Предложенные La Villa индивидуальные, подобранные специально для Вас туры и иные активности позволят Вам лучше познакомиться с потрясающей красотой природы и достопримечательностями Черногории.\n\n' +
      'Захотите ли Вы арендовать яхту на целый день, прокатиться на лодке по Будванскому заливу или заказать тур на подводной лодке, будет ли  Вам нужен трансфер из аэропортов Тивата, Подгорицы или Дубровника, наша команда организует все для Вашего удобства так, чтобы Вы получили максимальное удовольствие  от своего пребывания у нас.\n\n' +
      'Среди наиболее популярных среди наших гостей развлечений – однодневные путешествия по заливам Будвы и Боки, походы на каяках и САП-досках, винные и гастрономические черногорские туры, путешествия на Скадарское озеро и другие.',
  },
  restaurants: {
    common: { body: abstract },
    left: {
      title: 'Shanghai',
      linkTo: '/restaurant/shanghai',
      logo: require('../../../assets/images/shanghaiLogo.png'),
      cover: shanghaiCover,
      cover1: shanghaiCover1,
      body: shanghaiAbout,
    },
    right: {
      title: 'LaVilla',
      linkTo: '/restaurant/lavilla',
      logo: require('../../../assets/images/laVillaLogo.png'),
      cover: laVilaCover,
      body: lavillaAbout,
    },
  },
  team: {
    title: 'Почему La Villa?',
    about:
      'Потому что мы хотим организовать летний отдых по вашему вкусу, до мельчайших деталей.\nПотому что отпуск, которого Вы ждали весь год, будет именно таким, о котором мечтали.\nПотому что любезность, душевное тепло и хорошее настроение – это те вещи, которыми мы делимся с Вами от чистого сердца!',
    members: [
      // require('../../../assets/images/team/team1.jpeg'),
      // require('../../../assets/images/team/team2.jpeg'),
      require('../../../assets/images/team/team3.jpeg'),
      require('../../../assets/images/team/team4.jpeg'),
      // require('../../../assets/images/team/team5.jpeg'),
    ],
  },
};

export default frontpage;